module.exports = __webpack_public_path__ + "img/coinbankC27.2eb11ebc.jpg";